export function errorNotify(error, app) {
  let data = error.response.data;

  if (data.errors) {
    let k = 0;
    Object.keys(data.errors).forEach((item) => {
      let err = data.errors[item];
      k++;
      for (let i = 0; i < err.length; i++) {
        setTimeout(() => {
          app.$notify({
            title: 'Ошибка',
            message: err[i],
            icon: "ti-alert",
            horizontalAlign: 'right',
            verticalAlign: 'top',
            type: 'warning'
          });
        }, 100 * k);
      }
    });
  }
}

export function cardContent(model = '', id = null, contentType = 'single', params = {}) {
  this.$loading(true);
  return this.$http
    .get(model, {
      params: {
        ...params,
        id: id,
      },
    })
    .then((response) => {
      if (contentType === 'single')
        return response.data;
      else if (contentType === 'list')
        return response.data;
      else if (contentType === 'page')
        return response.data.data;
    })
    .catch((error) => {
      errorNotify(error, this.$notify);
    })
    .finally(() => {
      setTimeout(() => {
        this.$loading(false);
      }, 400);
    });
}

export function cardUpdate(model = '', item = {}, method = 'put') {
  this.$loading(true);
  return this.$http
    ({
      url: model,
      method: method,
      data: item
    })
    .then((response) => {
      this.$store.dispatch("setLastUpdate", new Date());
      this.$notify({
        title: "Данные",
        message: "Данные успешно применились",
        icon: "ti-save",
        horizontalAlign: "right",
        verticalAlign: "top",
        type: "success",
      });
      if (response.data) {
        return response.data;
      }
      return null;
    })
    .catch((error) => {
      errorNotify(error, this.$notify);
      return null;
    })
    .finally(() => {
      setTimeout(() => {
        this.$loading(false);
      }, 400);
    });
}

